import React from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { MdOutlineDelete } from "react-icons/md";

const ExtraItems = ({
  itemName,
  editAction,
  DeleteAction,
  toggleAction,
  orderAmount,
}) => {
  return (
    <>
      <div className="mt-4 space-y-3 px-3 md:px-8 md:border md:border-gray-100 md:rounded-xl md:shadow-sm md:p-4">
        <div className="flex justify-between gap-4">
          <h1 className="text-base text-[#191919] text-start">{itemName}</h1>
          <div className="flex gap-3 justify-end">
            <button className="cursor-pointer" onClick={editAction}>
              <HiOutlinePencil size={24} className="text-[#1EC76C]" />
            </button>
            <button className="cursor-pointer" onClick={DeleteAction}>
              <MdOutlineDelete size={24} className="text-[#F44336]" />
            </button>
            <button>{toggleAction}</button>
          </div>
        </div>
        <div>
          <p className="font-bold texted-base text-[#FF6943]">${orderAmount}</p>
        </div>
      </div>
    </>
  );
};

export default ExtraItems;
